import { all, call, put, takeLatest } from 'redux-saga/effects'
import PublicationActions, { PublicationTypes } from 'Redux/PublicationRedux'

// Generate metadata
export function* generateMetadata(api, action) {
  try {
    const { videoId } = action
    const resp = yield call(api.generatePublishMetadata, videoId)

    if (resp.ok) {
      yield put(PublicationActions.publicationGenerateMetadataSuccess(resp.data))
      if (action.callback) {
        action.callback(resp.data, null)
      }
    } else {
      const error = resp.data?.error || 'Failed to generate metadata'
      yield put(PublicationActions.publicationGenerateMetadataFailure(error))
      if (action.callback) {
        action.callback(null, error)
      }
    }
  } catch (error) {
    const errorMsg = error.message || 'Failed to generate metadata'
    yield put(PublicationActions.publicationGenerateMetadataFailure(errorMsg))
    if (action.callback) {
      action.callback(null, errorMsg)
    }
  }
}

// Generate metadata by script (no video needed)
export function* generateMetadataByScript(api, action) {
  try {
    const { scriptId } = action
    const resp = yield call(api.generatePublishMetadataByScript, scriptId)

    if (resp.ok) {
      yield put(PublicationActions.publicationGenerateMetadataSuccess(resp.data))
      if (action.callback) {
        action.callback(resp.data, null)
      }
    } else {
      const error = resp.data?.error || 'Failed to generate metadata'
      yield put(PublicationActions.publicationGenerateMetadataFailure(error))
      if (action.callback) {
        action.callback(null, error)
      }
    }
  } catch (error) {
    const errorMsg = error.message || 'Failed to generate metadata'
    yield put(PublicationActions.publicationGenerateMetadataFailure(errorMsg))
    if (action.callback) {
      action.callback(null, errorMsg)
    }
  }
}

// Save metadata
export function* saveMetadata(api, action) {
  try {
    const { scriptId, platforms } = action
    const resp = yield call(api.savePublishMetadata, scriptId, platforms)

    if (resp.ok) {
      yield put(PublicationActions.publicationSaveMetadataSuccess(resp.data))
      if (action.callback) {
        action.callback(resp.data, null)
      }
    } else {
      const error = resp.data?.error || 'Failed to save metadata'
      yield put(PublicationActions.publicationSaveMetadataFailure(error))
      if (action.callback) {
        action.callback(null, error)
      }
    }
  } catch (error) {
    const errorMsg = error.message || 'Failed to save metadata'
    yield put(PublicationActions.publicationSaveMetadataFailure(errorMsg))
    if (action.callback) {
      action.callback(null, errorMsg)
    }
  }
}

// Load metadata
export function* loadMetadata(api, action) {
  try {
    const { scriptId } = action
    const resp = yield call(api.loadPublishMetadata, scriptId)

    if (resp.ok) {
      yield put(PublicationActions.publicationLoadMetadataSuccess(resp.data))
      if (action.callback) {
        action.callback(resp.data, null)
      }
    } else {
      const error = resp.data?.error || 'Failed to load metadata'
      yield put(PublicationActions.publicationLoadMetadataFailure(error))
      if (action.callback) {
        action.callback(null, error)
      }
    }
  } catch (error) {
    const errorMsg = error.message || 'Failed to load metadata'
    yield put(PublicationActions.publicationLoadMetadataFailure(errorMsg))
    if (action.callback) {
      action.callback(null, errorMsg)
    }
  }
}

// Create publication
export function* createPublication(api, action) {
  try {
    const { videoId, params } = action
    const resp = yield call(api.createPublication, videoId, params)

    if (resp.ok) {
      yield put(PublicationActions.publicationCreateSuccess(resp.data))
      if (action.callback) {
        action.callback(resp.data, null)
      }
    } else {
      const error = resp.data?.error || 'Failed to create publication'
      yield put(PublicationActions.publicationCreateFailure(error))
      if (action.callback) {
        action.callback(null, error)
      }
    }
  } catch (error) {
    const errorMsg = error.message || 'Failed to create publication'
    yield put(PublicationActions.publicationCreateFailure(errorMsg))
    if (action.callback) {
      action.callback(null, errorMsg)
    }
  }
}

// Send email
export function* sendEmail(api, action) {
  try {
    const { videoId, publicationId, email } = action
    const resp = yield call(api.sendPublicationEmail, videoId, publicationId, email)

    if (resp.ok) {
      yield put(PublicationActions.publicationSendEmailSuccess(resp.data))
      if (action.callback) {
        action.callback(resp.data, null)
      }
    } else {
      const error = resp.data?.error || 'Failed to send email'
      yield put(PublicationActions.publicationSendEmailFailure(error))
      if (action.callback) {
        action.callback(null, error)
      }
    }
  } catch (error) {
    const errorMsg = error.message || 'Failed to send email'
    yield put(PublicationActions.publicationSendEmailFailure(errorMsg))
    if (action.callback) {
      action.callback(null, errorMsg)
    }
  }
}

// List publications
export function* listPublications(api, action) {
  try {
    const { videoId } = action
    const resp = yield call(api.getPublications, videoId)

    if (resp.ok) {
      yield put(PublicationActions.publicationListSuccess(resp.data))
      if (action.callback) {
        action.callback(resp.data, null)
      }
    } else {
      const error = resp.data?.error || 'Failed to list publications'
      yield put(PublicationActions.publicationListFailure(error))
      if (action.callback) {
        action.callback(null, error)
      }
    }
  } catch (error) {
    const errorMsg = error.message || 'Failed to list publications'
    yield put(PublicationActions.publicationListFailure(errorMsg))
    if (action.callback) {
      action.callback(null, errorMsg)
    }
  }
}

// Watcher saga
export default function* publicationSaga(api) {
  yield all([
    takeLatest(PublicationTypes.PUBLICATION_GENERATE_METADATA_REQUEST, generateMetadata, api),
    takeLatest(PublicationTypes.PUBLICATION_GENERATE_METADATA_BY_SCRIPT_REQUEST, generateMetadataByScript, api),
    takeLatest(PublicationTypes.PUBLICATION_SAVE_METADATA_REQUEST, saveMetadata, api),
    takeLatest(PublicationTypes.PUBLICATION_LOAD_METADATA_REQUEST, loadMetadata, api),
    takeLatest(PublicationTypes.PUBLICATION_CREATE_REQUEST, createPublication, api),
    takeLatest(PublicationTypes.PUBLICATION_SEND_EMAIL_REQUEST, sendEmail, api),
    takeLatest(PublicationTypes.PUBLICATION_LIST_REQUEST, listPublications, api),
  ])
}
